// eslint-disable-next-line import/no-cycle
import { getApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({
		docError: null,
	}),
	mutations: {
		SET_CONTRACT_DOCS_ERROR(state, val) {
			state.docError = val;
		},
	},
	actions: {
		async fetchDocs() {
			const response = await getApi('/k5/v1/contract/get-files-list');
			return response;
		},
		async fetchSingleDoc(state, { uid }) {
			const response = await getApi(`/k5/v1/contract/get-file?file_uid=${uid}`);
			return response;
		},
	},
};
